/* eslint-disable no-undef */
import ElementPlus from 'element-plus'
export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.use(ElementPlus, { size: 'small' })
})
